export const INFO = {
    branch: 'GN-13160',
    sprintTimestamp: 1703710878,
};
